function isFieldError(array, val) {
	return array.includes(val);
}

const SelectUncontrolled = ({
	label,
	req,
	name,
	data,
	value,
	errors,
	autocomplete = "off",
}) => {
	return (
		<div className="select">
			<label htmlFor={name} className={!label ? "hidden" : ""}>
				{`${label}`} {req ? <span className="error">*</span> : null}
			</label>
			<select
				name={name}
				id={name}
				defaultValue={value}
				autoComplete={autocomplete}
				className={isFieldError(errors, name) ? "error-border" : ""}
			>
				{data.map((item, index) => {
					return (
						<option key={index} value={item.value}>
							{item.name}
						</option>
					);
				})}
			</select>
		</div>
	);
};

export default SelectUncontrolled;
